type TelegramWebApp = {
  initData?: string;
  ready?: () => void;
  expand?: () => void;
};

type TelegramNamespace = {
  WebApp?: TelegramWebApp;
};

const getWebApp = (): TelegramWebApp | undefined => {
  const tg = (window as unknown as { Telegram?: TelegramNamespace }).Telegram;
  return tg?.WebApp;
};

export const getInitData = (): string => getWebApp()?.initData ?? '';

export const isInTelegram = (): boolean => Boolean(getWebApp()?.initData);

export const initTelegramWebApp = (): void => {
  const webApp = getWebApp();
  webApp?.ready?.();
  webApp?.expand?.();
};
